import { render, staticRenderFns } from "./CatalogItem.vue?vue&type=template&id=4d67edca&scoped=true&"
import script from "./CatalogItem.vue?vue&type=script&lang=js&"
export * from "./CatalogItem.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItem.vue?vue&type=style&index=0&id=4d67edca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d67edca",
  null
  
)

export default component.exports